import React, { useState,useEffect } from "react";
import Pregunta from "./components/Pregunta";
import Formulario from "./components/Formulario";
import Listado from './components/Listado';
import ControlPresupuesto from './components/ControlPresupuesto';

function App() {
	const [presupuesto, guardarPresupuesto] = useState(0);
	const [restante, guardarRestante] = useState(0);
	const [mostrarpregunta, actualizarPregunta] = useState(true);
	const [gastos,guardarGastos]=useState([]);
	const [gasto,guardarGasto]=useState({});
	const [creargasto,guardarCrearGasto]=useState(false);

	//actualiza el restante
	useEffect(()=>{
		if(creargasto){

			//agrega nuevo presupuesto
			guardarGastos([
				...gastos,
				gasto
			]);
			//restar el presupuesto actual
			const presupuestoRestante=restante-gasto.cantidad;
			guardarRestante(presupuestoRestante);

			//resetear a false
			guardarCrearGasto(false);
		}
	},[gasto,creargasto,gastos,restante])

	//cuando agregamos un nuevo gasto
	// const agregaNuevoGasto=gasto=>{
	// 	console.log("agregaNuevoGasto");
	// 	console.log(gasto);
	// 	// guardarGastos([
	// 	// 	...gastos,
	// 	// 	gasto
	// 	// ])
	// }

	return (
		<React.Fragment>
			<div className="container">
				<header>
					<h1>Gasto Semanal (Alexis)</h1>

					<div className="contenido-principal contenido">
						{mostrarpregunta ? (
							<Pregunta
								guardarPresupuesto={guardarPresupuesto}
								guardarRestante={guardarRestante}
								actualizarPregunta={actualizarPregunta}
							/>
						) : (
							<div className="row">
								<div className="one-half column">
									<Formulario 
									guardarGasto={guardarGasto}
									guardarCrearGasto={guardarCrearGasto}
									/>
								</div>
								<div className="one-half column">
									<Listado
										gastos={gastos}
									/>
									<ControlPresupuesto
										presupuesto={presupuesto}
										restante={restante}
									/>
								</div>
							</div>
						)}
					</div>
				</header>
			</div>
		</React.Fragment>
	);
}

export default App;
